import { Container, ContainerProps } from '@mui/material'

const ZContainer = (props: ContainerProps) => {
  const { style, children, ...rest } = props

  return (
    <Container
      disableGutters
      maxWidth={false}
      style={{
        display: 'flex',
        flex: 1,
        alignItems: 'center',
        height: '100vh',
        flexDirection: 'column',
        width: '100%',
        maxWidth: '430px',
        margin: '0 auto',
        paddingTop: '3rem',
        ...style,
      }}
      {...rest}
    >
      {children}
    </Container>
  )
}

export default ZContainer
